let presetTime = {};
function setTime() {
  const dateObj = new Date();
  const today = new Date(dateObj.getTime());
  const yesterday = new Date(dateObj.getTime() - 86400000);
  const weekDay = dateObj.getDay();
  const lastMonthStartDate = new Date(dateObj.getFullYear(), dateObj.getMonth() - 1, 1);
  const lastMonthEndDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), 1);
  const lastMonthDays = (lastMonthEndDate - lastMonthStartDate) / (1000 * 60 * 60 * 24);

  //时间格式化
  Date.prototype.Format = function (flag) {
    let fmt = 'yyyy-MM-dd hh:mm:ss';
    let isBase = flag === 'default';
    let isStart = flag === 'start';
    let o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": isBase ? this.getHours() : isStart ? 0 : 23, //小时
      "m+": isBase ? this.getMinutes() : isStart ? 0 : 59, //分
      "s+": isStart ? 0 : 59,//this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  };
  // 昨天
  presetTime.yesterday = {
    from: yesterday.Format('start'),
    to: yesterday.Format('end')
  };
  console.log(presetTime.yesterday, 'presetTime.yesterdaypresetTime.yesterday?')
  // 今天
  presetTime.today = {
    from: new Date().Format('start'),
    to: new Date().Format('end')
  };
  // 上周
  presetTime.lastWeek = {
    from: weekDay === 0 ? new Date(dateObj.getTime() - 86400000 * (6 + 7)).Format('start') : new Date(dateObj.getTime() - 86400000 * (weekDay - 1 + 7)).Format('start'),
    to: weekDay === 0 ? new Date(dateObj.getTime() - 86400000 * 7).Format('end') : new Date(dateObj.getTime() - 86400000 * weekDay).Format('end')
  };
  // 本周
  presetTime.currentWeek = {
    from: weekDay === 0 ? new Date(dateObj.getTime() - 86400000 * 6).Format('start') : new Date(dateObj.getTime() - 86400000 * (weekDay - 1)).Format('start'),
    to: dateObj.Format('end')
    // to: new Date(dateObj.getTime() - 86400000 * (weekDay - 1) + (86400000 * 6)).Format('end')
  };
  // 上月
  presetTime.lastMonth = {
    from: new Date(dateObj.getFullYear(), dateObj.getMonth() - 1, 1).Format('start'),
    to: new Date(dateObj.getFullYear(), dateObj.getMonth() - 1, lastMonthDays).Format('end')
  };
  // 本月
  presetTime.currentMonth = {
    from: new Date(dateObj.getFullYear(), dateObj.getMonth(), 1).Format('start'),
    to: dateObj.Format('end')
    // to: new Date(dateObj.getFullYear(), dateObj.getMonth(), new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0).getDate()).Format('end')
  };
  // 去年
  presetTime.lastYear = {
    from: new Date(dateObj.getFullYear() - 1, 0, 1).Format('start'),
    to: new Date(dateObj.getFullYear() - 1, 11, 31).Format('end')
  };
  // 今年
  presetTime.currentYear = {
    from: new Date(dateObj.getFullYear(), 0, 1).Format('start'),
    to: dateObj.Format('end')
  };
  // 过去7天
  presetTime.lastSevenDays = {
    from: new Date(dateObj.getTime() - 86400000 * 7).Format('start'),
    to: yesterday.Format('end')
  };
  // 过去30天
  presetTime.lastThirtyDays = {
    from: new Date(dateObj.getTime() - 86400000 * 30).Format('start'),
    to: yesterday.Format('end')
  };
  // 最近31天
  presetTime.lately31Days = {
    from: new Date(dateObj.getTime() - 86400000 * 30).Format('start'),
    to: today.Format('end')
  };

  presetTime.upToDate = {
    from: new Date(0).Format('start'),
    to: dateObj.Format('end')
  };

  presetTime.lastNDays = ([n]) => {
    return {
      from: new Date(dateObj.getTime() - 86400000 * n).Format('start'),
      to: yesterday.Format('end')
    }
  };

  presetTime.m2nDaysAgo = ([m, n]) => {
    return {
      from: new Date(dateObj.getTime() - 86400000 * m).Format('start'),
      to: new Date(dateObj.getTime() - 86400000 * n).Format('end')
    }
  };
}

setTime()
setInterval(() => {
  setTime()
}, 1000 * 10)
export default presetTime;



// WEBPACK FOOTER //
// ./src/libs/time.js